export const THIRD_PARTY = 'third-party';
export const MOTOR = 'motor';
export const TRAVEL = 'travel';
export const ELECTRONIC_EQUIPMENTS = 'electronic-equipment';
export const ELEVATOR = 'elevator';
export const FIRE = 'fire';
export const EARTHQUAKE = 'earthquake';
export const CAR_BODY = 'car-body';
export const HEALTH = 'health';
export const HEALTH_GROUP = 'health-group';
export const HEALTH_ONLINE = 'health-online';
export const HEALTH_FOREIGNERS = 'health-foreigners';
export const MEDICAL_LIABILITY = 'medical-liability';
export const TRAVEL_PLUS = 'travel-plus';
export const MANUAL = 'manual';
export const CORONA = 'corona';
export const PILGRIMAGE = 'pilgrimage';
export const PERSONAL_ACCIDENT = 'personal-accident';
export const SPORTS = 'sports';
export const BUSINESS_FIRE = 'business-fire';
export const SPECIAL_EQUIPMENTS = 'electronics-saman';
export const PILGRIMAGE_ONLINE = 'pilgrimage-online';
export const BARAN_LIFE = 'baran-life';
export const WAR = 'war';

const router = () => {
  const local = JSON.parse(localStorage?.getItem('app-store'));
  const branchWithShowType = local?.state.business?.BranchWithShowType;

  const links = [
    {
      name: THIRD_PARTY,
      path: '/thirdparty',
      description: "در هنگام رانندگی، نگران خسارت تصادف نباشید.",
      faName: 'شخص ثالث',
      insuranceFaName: 'بیمه شخص ثالث',
      footerTitle: 'خرید بیمه شخص ثالث',

    },
    {
      name: MOTOR,
      path: '/thirdpartyMotor',
      hasInstallments: false,
      description: "ریسک تصادف با موتور را کاهش دهید.",
      faName: 'موتور',
      insuranceFaName: 'بیمه موتور سیکلت',
      footerTitle: 'بیمه موتور سیکلت',

    },
    {
      name: CAR_BODY,
      path: '/carbody',
      description: "خودروی شما سرمایه شماست؛ مراقب آن باشید.",
      faName: 'بدنه',
      insuranceFaName: 'بیمه بدنه خودرو',
      footerTitle: 'بیمه بدنه خودرو',

    },
    {
      name: FIRE,
      path: '/fire',
      description: "پوشش آتش سوزی، سیل و سایر حوادث طبیعی ",
      faName: 'آتش سوزی',
      insuranceFaName: 'بیمه آتش سوزی',
      footerTitle: 'بیمه آتش سوزی ساختمان',

    },
    {
      name: EARTHQUAKE,
      path: '/earthquake',
      description: "حفاظت از املاک و سرمایه‌های خود در مناطق زلزله‌خیز",
      faName: 'زلزله',
      insuranceFaName: 'بیمه زلزله',
      footerTitle: 'خرید بیمه زلزله',

    },
    {
      name: PILGRIMAGE,
      path: '/holyshrines-travel',
      description: "بدون دغدغه به سفر زیارتی کربلا بروید.",
      faName: 'سفر کربلا',
      insuranceFaName: 'بیمه کربلا و اربعین',
      footerTitle: 'بیمه اربعین',
      color: 'red',

    },
    {
      name: PILGRIMAGE_ONLINE,
      path: '/holyshrines-travel',
      description: "بدون دغدغه به سفر زیارتی کربلا بروید.",
      faName: 'کربلا',
      insuranceFaName: 'بیمه کربلا و اربعین',
      color: 'red',

    },
    {
      name: HEALTH,
      path: '/health',
      hasInstallments: false,
      faName: 'تکمیلی درمان',
      insuranceFaName: 'بیمه تکمیلی درمان',
      description: "بخاطر هزینه ها، درمان‌تان را عقب نیندازید.",
      footerTitle: 'قیمت بیمه تکمیلی',

    },
    {
      name: HEALTH_GROUP,
      path: '/health-group',
      insuranceFaName: 'بیمه تکمیلی گروهی',
      faName: 'تکمیلی گروهی ',
      description: "بخاطر هزینه ها، درمان‌تان را عقب نیندازید.",
      footerTitle: 'بیمه تکمیلی گروهی',

    },
    {
      name: TRAVEL,
      path: '/travel',
      description: "نگران اتفاقات احتمالی سفر نباشید",
      faName: 'مسافرتی',
      insuranceFaName: 'بیمه مسافرتی',
      footerTitle: 'خرید بیمه مسافرتی',

    },
    {
      name: BARAN_LIFE,
      path: '/life',
      description: "سرمایه‌گذاری کم‌ریسک و مطمئن، دریافت مستمری ماهانه با احتساب تورم",
      faName: 'مستمری',
      insuranceFaName: 'بیمه مستمری',
      footerTitle: 'بیمه مستمری',
      color: 'red',

    },
    {
      name: TRAVEL_PLUS,
      path: '/travelplus',
      isOnline: false,
      description: "بیمه‌ای منحصر‌به‌فرد با بالاترین سقف پوشش‌ها در سفر",
      faName: 'مسافرتی سامان',
      insuranceFaName: 'بیمه مسافرتی سامان',
      footerTitle: 'بیمه مسافرتی سامان',

    },
    // {
    //   name: HEALTH_FOREIGNERS,
    //   path:  '/health-foreigners',
    //   isOnline: false,
    //   description: "",
    //   faName: 'درمان اتباع خارجی',
    //   insuranceFaName: 'درمان اتباع خارجی',
    // },
    {
      name: ELECTRONIC_EQUIPMENTS,
      path: '/equipments',
      description: "پوشش سرقت، شکستگی و نوسانات برق",
      faName: 'تجهیزات الکترونیک',
      insuranceFaName: 'بیمه تجهیزات الکترونیک',
      footerTitle: '',

    },
    {
      name: SPECIAL_EQUIPMENTS,
      path: '/equipments',
      description: "پوشش سرقت، شکستگی و نوسانات برق",
      faName: 'موبایل',
      insuranceFaName: 'بیمه موبایل',
      footerTitle: 'بیمه گوشی',

    },
    {
      name: MEDICAL_LIABILITY,
      path: '/medical-liability',
      description: "با اطمینان خاطر به درمان بیماران بپردازید.",
      faName: 'مسئولیت پزشکان',
      insuranceFaName: 'بیمه مسئولیت پزشکان',
      footerTitle: 'خرید بیمه مسئولیت پزشکان',

    },
    {
      name: ELEVATOR,
      path: '/elevator',
      description: "نگران خسارت‌های ناشی از حوادث آسانسور نباشید.",
      faName: 'آسانسور',
      insuranceFaName: ' بیمه آسانسور',
      footerTitle: 'خرید بیمه آسانسور',

    },
    {
      name: PERSONAL_ACCIDENT,
      path: '/personal-accident',
      isNew: true,
      description: "پشتیبان مطمئن شما در حوادث غیرمنتظره",
      faName: 'حوادث انفرادی',
      insuranceFaName: 'حوادث انفرادی',
      footerTitle: 'حوادث انفرادی',

    },
    {
      name: SPORTS,
      path: '/sports',
      description: "پوشش هزینه‌های درمانی، ازکارافتادگی و غرامت فوت هنگام ورزش",
      faName: 'ورزشی',
      insuranceFaName: 'بیمه ورزشی',
      footerTitle: 'خرید بیمه ورزشی آنلاین',

    },

    {
      name: BUSINESS_FIRE,
      path: '/business-fire',
      faName: 'آتش سوزی تجاری',
      insuranceFaName: 'بیمه آتش سوزی تجاری',
      description: "پوشش آتش سوزی، سیل و سایر حوادث طبیعی ",
      footerTitle: '',

    },
    {
      name: MANUAL,
      path: '/others',
      faName: 'سایر بیمه ها',
      description: "",
      insuranceFaName: 'سایر بیمه ها',
      footerTitle: '',

    },
    {
      name: WAR,
      path: '/war',
      faName: 'جنگ ساختمان',
      description: "در برابر پیامدهای جنگ، آسوده‌خاطر باشید.",
      insuranceFaName: 'بیمه جنگ ساختمان',
      footerTitle: 'بیمه جنگ ساختمان',

    },
  ];
  return { links }
}

export default router